import { JetView } from 'webix-jet';
import { devConfig, profile } from 'config/config';

/**
 * Class representing the FilterProvidersThirdView.
 * @extends JetView
 */
export default class FilterProvidersThirdView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing ID and Partner fields
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Id',
                    type: 'number',
                    label: _("<span class='icon-drivers-license-o'></span>ID"),
                    labelPosition: 'top',
                    placeholder: _('ID'),
                },
                {
                    view: 'richselect',
                    name: 'Partner',
                    label: _('Partner'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    value: profile.PartnerSelected, // Default selected partner
                    options: profile.Partners, // Available partners
                    id: 'Partners',
                },
            ],
        };

        // Center left section containing Name and Country fields
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Name',
                    label: "<span class='icon-user'></span>" + _('Nombre'),
                    labelPosition: 'top',
                    placeholder: _('Nombre'),
                },
                {
                    view: 'richselect',
                    name: 'Country',
                    localId: 'regions:combo',
                    label: "<span class='icon-language'></span>" + _('País'),
                    hidden: !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility
                    css: 'prm-filterByCountry',
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    value: profile.Partners[0].Countries[0].id, // Default country
                    options: profile.Partners[0].Countries, // Available countries
                    id: 'Countries',
                },
            ],
        };

        // Center right section containing NIT field
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Nit',
                    label: "<span class='icon-profile1'></span>" + _('RUC - NIT'),
                    labelPosition: 'top',
                    placeholder: _('RUC - NIT'),
                },
            ],
        };

        // Right section containing State field
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect',
                    name: 'State',
                    label: "<span class='icon-state'></span>" + _('Estado'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [
                        { id: 'null', value: _('Todos') }, // All states option
                        { id: 'A', value: _('Activado') }, // Activated state
                        { id: 'I', value: _('Inactivado') }, // Inactivated state
                    ],
                },
            ],
        };

        // Upper section containing the four main input areas
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right],
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 5,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Añadir Proveedor'), // Add Provider button
                    type: 'form',
                    autowidth: true,
                    hidden: !devConfig.getPermAction('accountingProvidersAdd', 'Add'), // Conditional visibility
                    css: 'prm-accountingProvidersAdd',
                    click: () => {
                        this.app.callEvent('addProvidersThird:button', [{}]); // Event for adding provider
                    },
                },
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Consult button
                    hotkey: 'enter', // Enter key shortcut
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('ProvidersThird:filter', [filterdata]); // Event for filtering providers
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
